import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'

import { REACT_APP_BASE_SURVEY_URL } from '../../config/settings/environment'
import { Iframe, Root } from './Iframe.styles'

/**
 * The CustomIframe's component.
 */
const CustomIframe = ({ accessToken, quoteCode }) => {
  const [iframeUrl, setIframeUrl] = useState('')
  const [showSurvey, setShowSurvey] = useState(false)

  const iframeRef = useRef(null)

  useEffect(() => {
    const fetchTokenAndSetUrl = async () => {
      setIframeUrl(`${REACT_APP_BASE_SURVEY_URL}/encuestas?id=${quoteCode}&origin=1&access_token=${accessToken}`)
    }

    fetchTokenAndSetUrl()
  }, [])

  useEffect(() => {
    const handleMessage = event => {
      if (event.data?.type === 'SURVEY_HEIGHT_UPDATE') {
        const newHeight = event.data.height

        if (iframeRef.current) {
          iframeRef.current.style.height = `${newHeight}px`
        }
      }

      if (event.data?.type === 'SHOW_SURVEY_FORM') {
        setShowSurvey(event.data.show)
      }
    }

    window.addEventListener('message', handleMessage)

    return () => window.removeEventListener('message', handleMessage)
  }, [])

  return (
    <Root>
      <Iframe ref={iframeRef} scrolling="no" src={iframeUrl} style={{ display: showSurvey ? 'block' : 'none' }} />
    </Root>
  )
}

CustomIframe.propTypes = {
  accessToken: PropTypes.string.isRequired,
  quoteCode: PropTypes.string.isRequired
}

export default CustomIframe
